import { getChartLabelIdOrName } from '@modules/charts/utils';
import { EqlFieldName } from '@modules/common/constants';
import { FieldNames } from 'v2/core/entities/fields';

interface GetMetricKeyIDProps {
  id?: string;
  isSingleRecordQuery?: boolean;
  field: string | undefined;
}

export const getMetricKeyID = ({
  id,
  isSingleRecordQuery,
  field,
}: GetMetricKeyIDProps) => {
  if (isSingleRecordQuery) {
    return undefined;
  }

  if (field === FieldNames.Source || field === EqlFieldName.Source) {
    return id;
  }

  return getChartLabelIdOrName(id);
};
